import ReactDOM from 'react-dom/client';
import App from './App';

import './index.css';
import { SDKProps } from './type';

declare global {
  interface Window {
    JoyGameSDK: any;
    JoyGameSDKInstance: any;
  }
}


class JoyGameSDK {
  constructor(props: SDKProps) {
    this.initApp(props);
  }

  private initApp = (props: SDKProps) => {
    // Local (`yarn dev`): CSS đã có qua import './index.css'
    // Production build: game nhúng script SDK → load CSS cùng host với latest.js
    if (process.env.NODE_ENV === 'production') {
      const sdkBase = (process.env.REACT_APP_SDK_BASE_URL || 'https://nap.joyplay.vn/sdk').replace(/\/$/, '');
      const cssHref = process.env.REACT_APP_SDK_CSS_URL || `${sdkBase}/latest.css`;
      if (!document.getElementById('joygames-style')) {
        const link = document.createElement('link');
        link.id = 'joygames-style';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = cssHref;
        link.media = 'all';
        // !!!! QUAN TRỌNG: prepend vào ĐẦU <head> (KHÔNG append cuối)
        // File latest.css CDN này là CSS LEGACY cũ của team trước, còn chứa các
        // rule text-align center overwrite CSS index.css mới chính của dev.
        // Cho latest.css vào ĐẦU head → browser tính cascade rule TRƯỚC →
        // <style> bundle main.css của webpack (được inject sau) sẽ ghi đè LÊN
        // → CSS index.css luôn thắng, không bị CDN cũ phá vỡ layout nữa.
        // Nếu dev muốn tắt hoàn toàn latest.css → set REACT_APP_SDK_CSS_URL=about:blank
        // hoặc override SDK prop cssUrl.
        if (document.head.firstChild) {
          document.head.insertBefore(link, document.head.firstChild);
        } else {
          document.head.appendChild(link);
        }
      }
    }

    const existingSdkUIElement = document.getElementsByTagName('joygames-sdk')[0];
    if (existingSdkUIElement) {
      return;
      //existingSdkUIElement.remove();
    }
    const sdkUIElement = document.createElement('joygames-sdk');
    document.body.appendChild(sdkUIElement);
    const root = ReactDOM.createRoot(sdkUIElement);
    root.render(<App
      ref={(ref: any) => {
        window.JoyGameSDKInstance = ref;
      }}
      {...props}
    />);
  };
}

if (!window.JoyGameSDK) {
  // already exist!
  window.JoyGameSDK = JoyGameSDK;
}
